module.exports = "/_next/static/images/car-carousel-80306d22521c107d8357d5546437d83c.png";